import axios from '@axios'
import ApiRouteProvider from '../route'

export default {
    getS2sKey(organizationId) {
        return axios.get(ApiRouteProvider.echa.getS2SKey(organizationId));
    },
    saveS2SKey(organizationId, username, legalEntityUuid, s2sKey) {
        return axios.put(ApiRouteProvider.echa.saveS2SKey(organizationId), {
            username, legalEntityUuid, s2sKey
        })
    }
}
